import { render, staticRenderFns } from "./totalStat.vue?vue&type=template&id=256da81f&scoped=true"
import script from "./totalStat.vue?vue&type=script&lang=ts"
export * from "./totalStat.vue?vue&type=script&lang=ts"
import style0 from "./totalStat.vue?vue&type=style&index=0&id=256da81f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256da81f",
  null
  
)

export default component.exports